<template>
  <div :class="['student-item', { 'student-item__small': isSmall, 'selected': isSelected }]">
    <div class="student-item__avatar">
      <img :class="['checkmark', { 'active': isSelected }]" src="@/assets/images/icons/check-circle-filled.svg" />
      <img :src="studentImage" />
    </div>
    <div class="student-item__wrapper">
      <div class="student-item__name">
        <span>{{ student.firstName }}</span>
      </div>
      <div class="student-item__archived" v-if="isArchived">
        (archiwum)
      </div>
    </div>

  </div>
</template>

<script>
import avatarGirl from '@/assets/images/avatar/avatar_girl.png';
import avatarBoy from '@/assets/images/avatar/avatar_boy.png';

export default {
  name: 'StudentItem',

  props: {
    student: Object,
    isSmall: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    studentImage() {
      const { firstName, id } = this.student;
      const firstNameToLowerCase = firstName.toLowerCase();
      const nameExceptions = [
        'kuba',
        'zawisza',
        'jarema',
        'barnaba',
        'bonawentura',
        'kosma',
        'rokita',
        'lasota',
        'żegota',
        'jan maria',
        'nikita',
        'makita',
        'illia',
      ];
      const idExceptions = [126619];
      const nameValid = ['noemi', 'miriam', 'beatrycze', 'sophie', 'nikol'];
      const isLastLetterA = firstName.slice(-1) === 'a';

      return (isLastLetterA
        && !nameExceptions.includes(firstNameToLowerCase))
        || nameValid.includes(firstNameToLowerCase) || idExceptions.includes(id)
        ? avatarGirl
        : avatarBoy;
    },
    isArchived() {
      const { isArchived } = this.student || {};

      return isArchived;
    },
  },
};
</script>

<style lang="scss" scoped>
.student-item {
  position: relative;

  .checkmark {
    opacity: 0;
    border: 0 !important;
    position: absolute !important;
    width: 24px !important;
    height: 24px !important;
    top: -7px;
    right: -7px;
    transition: 0.3s;
  }

  .active {
    opacity: 1;
  }

  @apply flex flex-row p-3 px-12 cursor-pointer;

  @media screen and (min-width: 768px) {
    @apply w-1/2 justify-start;
  }

  @media screen and (min-width: 992px) {
    @apply w-1/3;
  }

  &:hover>&__avatar {
    @apply border-pink;
    box-shadow: 0 7px 14px rgba(0, 0, 0, 0.05), 0 5px 5px rgba(0, 0, 0, 0.12);
  }

  &:hover>&__name {
    @apply text-grey-darkest;
  }

  &__avatar,
  &__name {
    @apply flex justify-center items-center mx-0 px-0 text-lg;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

    @media screen and (min-width: 768px) {
      @apply text-2xl px-3;
    }
  }

  &__name {
    @media screen and (min-width: 768px) {
      @apply text-2xl;
    }
  }

  &__wrapper{
    @apply flex flex-col justify-center items-center;
    gap: 8px;
  }

  &__archived {
    @apply text-grey-darker
  }

  &__avatar {
    @apply p-0 mx-6 bg-white border-solid border-6 border-grey;
    width: 115px;
    height: 115px;
    border-radius: 34px;

    img {
      object-fit: cover;
      max-width: 105px;
    }
  }

  &__small {
    flex-direction: column;
    align-items: center;
    padding: 0;
    width: 64px;
    height: 64px;

    &.selected>.student-item__avatar img {
      border-color: #E10A7B;
    }

    &:hover>.student-item__avatar {
      box-shadow: none;
    }

    &:hover>.student-item__avatar img {
      border-color: #E10A7B;
    }

    .student-item__avatar {
      border-width: 1px;
      margin-left: 0;
      margin-right: 0;
      width: 64px;
      height: 64px;
    }

    .student-item__avatar img {
      -webkit-user-drag: none;
      width: 64px;
      height: 64px;
      border: 2px solid #E7E9EE;
      border-radius: 15px;
      transition: 0.3s;
    }

    .student-item__name {
      padding-top: 0.5rem;
      font-size: 14px;
      font-weight: 500;
      color: #111724;
    }
  }
}
</style>
